import React, { FC } from 'react'

interface Props {
  size?: number
}

export const FacebookIcon: FC<Props> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="16" fill="#3E85E9" />
    <rect
      x="0.214286"
      y="0.214286"
      width="31.5714"
      height="31.5714"
      rx="15.7857"
      stroke="white"
      strokeOpacity="0.2"
      strokeWidth="0.428571"
    />
    <path
      d="M17.2674 8C16.7261 8 16.2054 8.06473 15.5978 8.30207C14.363 8.79725 13.7337 9.96021 13.7337 11.7705V13.5376H12V16.4892H13.7337V24H17.2674V16.4881H19.6739L20 13.5376H17.2674V12.2009C17.2674 11.792 17.3109 11.49 17.4196 11.3184C17.5717 11.0595 17.875 10.9301 18.3511 10.9301H19.9554V8H17.2674Z"
      fill="#FFE9E9"
    />
  </svg>
)
